import { useEffect, useRef } from 'react';
/**
 * get previous render value
 * @param cb that get method of target value
 * @param isDefault if set `true`, the first time will get value from `cb`
 * @returns previous value get from `cb`
 */
export function usePrevious(cb, isDefault) {
    var ref = useRef(isDefault ? cb() : undefined);
    useEffect(function () {
        ref.current = cb();
    });
    return ref.current;
}
